import React, { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { procedureRecordingsAPI } from "../services/api";

export default function ProcedureVideoPlayer({ recording, onOpenChange }) {
  const [videoUrl, setVideoUrl] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!recording) return undefined;

    let disposed = false;
    let objectUrl = null;
    setVideoUrl(null);
    setError("");

    procedureRecordingsAPI
      .getVideo(recording.id)
      .then((response) => {
        if (disposed) return;
        objectUrl = URL.createObjectURL(response.data);
        setVideoUrl(objectUrl);
      })
      .catch((requestError) => {
        if (!disposed) {
          setError(
            requestError?.response?.data?.detail || "Não foi possível carregar este vídeo.",
          );
        }
      });

    return () => {
      disposed = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [recording]);

  return (
    <Dialog open={Boolean(recording)} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-5xl p-4 sm:p-6">
        <DialogHeader>
          <DialogTitle className="pr-8">{recording?.title}</DialogTitle>
          {recording?.description && (
            <p className="text-sm text-muted-foreground pr-8">{recording.description}</p>
          )}
        </DialogHeader>
        <div className="aspect-video rounded-lg overflow-hidden bg-black flex items-center justify-center">
          {!videoUrl && !error && <Loader2 className="w-7 h-7 text-white animate-spin" />}
          {error && <p className="px-6 text-center text-sm text-red-200">{error}</p>}
          {videoUrl && (
            <video src={videoUrl} controls autoPlay className="h-full w-full" controlsList="nodownload" />
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
